import { Component, Input, OnInit } from '@angular/core';

import { QrCodeModule } from 'ng-qrcode';
import { Router } from '@angular/router';
import { TosterService } from '@core/services/toster.service';
;
// import { NgxQRCodeModule, NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';

@Component({
    selector: 'app-qr-modal',
    imports: [QrCodeModule],
    templateUrl: './qr-modal.component.html',
    styleUrls: ['./qr-modal.component.scss']
})
export class QrModalComponent implements OnInit {
  
  @Input() qrData!: string;
  // elementType = NgxQrcodeElementTypes.URL;
  // correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  value = `upi://pay?ver=01&mode=15&am=1.00&cu=INR&pa=rnf.rnfmid0001.rnfisub001.rnfivpa001@cnrb&pn=RNFI%20SERVICES%20LIMITED&mc=4829&tr=CPPAYCP17151639172761789&tn=UPI%20_request%20from%20&mid=rnfmid0001&msid=rnfisub001&mtid=rnfivpa001&category=02&url=https://api.cipherpay.in&tid=CP17151639172761789`;
  constructor(
    // private router: Router, 
    // private toastr: TosterService,
    // 
    
    ) { }

  ngOnInit(): void {
    console.log("qr modal ---> ",this.qrData);
   
  }

  // maximize(){
  //   this.toastr.cleanupDynamicComponent();
  //   this.sidebarService.goToDashboard.next(true);
  //   this.router.navigate(['/products/qr']);
  // }
  // onCloseModal(){
  //   this.toastr.cleanupDynamicComponent();
  // }
  

//   isMaximize = false;
//   maximize() {
//     this.isMaximize = !this.isMaximize;
//  const modalDialog = document.getElementById('my-modal-dialog')as HTMLElement;
//  const modalBody= document.getElementById('my-modal-body')as HTMLElement;
//    modalDialog .style.maxWidth = '20%';
//    modalDialog .style.margin = 'auto';
//    modalDialog .style.display = 'inline';
//    modalDialog .style.transform = 'translate3d(75%, 25%, 0)';

//    modalBody .style.maxHeight = 'calc(100vh - 139px)';

// }

// restore() {
//     this.isMaximize = !this.isMaximize;
//     const modalDialog = document.getElementById('my-modal-dialog')as HTMLElement;
//     const modalBody= document.getElementById('my-modal-body')as HTMLElement;
//     modalDialog.style.maxWidth = '';
//     modalDialog.style.margin = '';
//     modalDialog.style.display = 'block';
//     modalDialog.style.top = '50%';
//     modalDialog.style.left = '50%';
//     modalDialog .style.transform = 'translate(-50%, -50%)';
//     modalBody.style.maxHeight = 'calc(100vh - 190px)';
// }

}
